import { Component } from '@angular/core';
import {HeaderComponent} from "../../header/header.component";
import {FooterComponent} from "../../footer/footer.component";
import {Router} from "@angular/router";

@Component({
  selector: 'vex-terms-conditions',
  standalone: true,
  imports: [
    HeaderComponent,
    FooterComponent
  ],
  templateUrl: './terms-conditions.component.html',
  styleUrl: './terms-conditions.component.scss'
})
export class TermsConditionsComponent {
  constructor(private router: Router) {
  }
  goTo(url) {
    this.router.navigateByUrl(url);
  }
}
